/**
 *  统计通道
 */
// tslint:disable:trailing-comma

export enum StatChannel {
  // 所有可用渠道
  LXAnalyticsAndMetric,
  // 灵犀
  LXAnalytics,
  // Raptor
  Raptor,
  // 自定义指标
  Metric,
}

/**
 * 灵犀上报类型
 */
export enum StatReportType {
  VIEW,
  CLICK,
  PV,
  SC,
}

/**
 * Raptor 模块错误级别
 */
export enum StatErrorLevel {
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
  Debug = 'debug',
}

/**
 * Raptor 模块错误分类
 */
export enum StatErrorCategory {
  JSError = 'jsError',
  ResourceError = 'resourceError',
  AJAXError = 'ajaxError',
}

export interface StatErrorModel {
  level?: StatErrorLevel;
  category?: StatErrorCategory;
  name: string;
  msg?: string;
  pos: string; // 报错位置编号（建议生成算法：Math.random().toString(36).slice(-4)
  custom?: object;
}

/**
 * 灵犀模块 - 上报参数
 */
export interface LXStatSendParams {
  cid?: string;
  bid?: string;
  lab?: any;
  enviroment?: any;
  options?: any;
  type: StatReportType;
}

/**
 * Raptor模块 - 上报参数
 */
export interface RaptorSendParams {
  // @ts-ignore
  error?: string | SubErrorType;
  combo?: boolean;
  level: StatErrorLevel;
  category: StatErrorCategory;
  tags?: PlainObject<Primitive>;
}

/**
 * Owl  模块必要的配置
 */
export interface OwlBasicConfig {
  [key: string]: any;
  project: string;
  pageUrl: string;
  devMode?: boolean;
}

export interface OwlAddErrorOptions {
  combo?: boolean;
  level: StatErrorLevel;
  category: StatErrorCategory;
  tags: PlainObject<Primitive>;
}

/********* 自定义纬度上报 ********/

export interface MetricSendParams {
  // 上报纬度
  key: string;
  // 上报数值
  value: number;
  // 纬度信息
  tags?: {
    [key: string]: any;
  };
  // 是否上报到 native 通道
  isNative?: boolean;
}

/**
 * 桥埋点位置
 */
export enum BridgeSendType {
  start = 'start',
  success = 'success',
  active = 'active',
  inactive = 'inactive',
}
